"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8.5 4.04a.5.5 0 0 1 .5.5v.746h6V4.54a.5.5 0 0 1 1 0v.746h2.497a1.5 1.5 0 0 1 1.5 1.5v11.71a1.5 1.5 0 0 1-1.5 1.5H5.54a1.5 1.5 0 0 1-1.5-1.5V6.786a1.5 1.5 0 0 1 1.5-1.5H8V4.54a.5.5 0 0 1 .5-.5M8 6.286H5.54a.5.5 0 0 0-.5.5V9h13.957V6.786a.5.5 0 0 0-.5-.5H16v.746a.5.5 0 0 1-1 0v-.746H9v.746a.5.5 0 0 1-1 0zm5.019 5.732a.5.5 0 0 0-.854-.354l-1.246 1.247a.5.5 0 1 0 .707.707l.393-.393v3.779a.5.5 0 1 0 1 0z"
}), 'CalendarFilled');
